import SaveBar from '@app/components/SaveBar'
import { bindFunctions } from '@app/utils/class'
import { humanize } from '@app/utils/formatting'
import * as React from 'react'
import DocumentTitle from 'react-document-title'
import { Action } from 'redux'

export interface IComponentProps {
  title: string
  onSaveClick: () => void
  onCancelClick: () => void
  saveDisabled: boolean
  hideButtons?: boolean
}

export interface IDispatchProps {
  errorToast: (title: string, message: string, options?: any) => Action<any>
}

type EditPageContainerProps = IComponentProps & IDispatchProps

export default class EditPageContainer extends React.Component<EditPageContainerProps> {
  private formRef: React.RefObject<HTMLFormElement>

  constructor(props: EditPageContainerProps) {
    super(props)

    this.formRef = React.createRef()

    bindFunctions(this)
  }

  public render() {
    return (
      <DocumentTitle title={this.props.title}>
        <div
          className='d-flex flex-column'
          style={{
            bottom: 0,
            left: 0,
            position: 'absolute',
            right: 0,
            top: 0,
          }}
        >
          <div style={{ flex: 1, overflowY: 'auto' }}>
            <form ref={this.formRef} autoComplete='off'>
              {this.props.children}
            </form>
          </div>
          {!this.props.hideButtons && (
            <SaveBar
              saveDisabled={this.props.saveDisabled}
              onSaveClick={this._onSave}
              onCancelClick={this.props.onCancelClick}
            />
          )}
        </div>
      </DocumentTitle>
    )
  }

  private _isValid() {
    return this.formRef.current && this.formRef.current.checkValidity()
  }

  private _onSave() {
    if (this._isValid()) {
      this.props.onSaveClick()
    } else if (this.formRef.current) {
      const formLength = this.formRef.current.length

      const invalidFields = []

      for (let i = 0; i < formLength; i++) {
        const elem = this.formRef.current[i] as HTMLInputElement

        if (elem.nodeName.toLowerCase() !== 'button') {
          if (elem.validity && !elem.validity.valid) {
            invalidFields.push(humanize(elem.name))
          }
        }
      }

      this.props.errorToast(
        'Validation Errors',
        `The following fields have validation errors:\n\n${invalidFields.join(
          '\n',
        )}`,
      )
    }
  }
}
